import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Axios from 'axios'
import { store } from './store'
import 'foundation-sites/dist/css/foundation.min.css'
import 'foundation-sites/dist/css/foundation-prototype.min.css'
import Storage from 'vue-ls'
import { VueReCaptcha } from 'vue-recaptcha-v3'
// For more options see below
Vue.use(VueReCaptcha, { siteKey: '6LfCdqkZAAAAAIwako4cu0uk8WSZvilNAmPX8-uR', loaderOptions: { autoHideBadge: true } })
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
  container: "body",
  duration: 400,
  easing: "ease",
  offset: -50,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
import VueSimpleAlert from "vue-simple-alert"
Vue.use(VueSimpleAlert)
 
const options = {
  namespace: 'ergovue__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
}
 
Vue.use(Storage, options)

Vue.config.productionTip = false

Vue.prototype.$sleep = function(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

Vue.prototype.$store = store
Vue.prototype.$http = Axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
